// English strings for P7-C (ANALYTICS-01…05, usage metering) (D-013: English only). Owned by that worker;
// spread into `en` as `en.analytics`, so keys read `t("analytics.…")`. Copy rules: DESIGN_SYSTEM §9.6.
// Sections: `reports` (the Reports area), `topics`, `dims`, `metrics`, `export`, `traffic` (the
// Analytics Engine activation state and the consent mode), `leaderboard`, `widgets` (Today).
export const analyticsStrings = {
  reports: {
    title: "Reports",
    lead: "Sales, products, money and delivery in Nepal time. Figures refresh within 15 minutes.",
    topicsLabel: "Report",
    from: "From",
    to: "To",
    dim: "Break down by",
    apply: "Show",
    updated: "Updated {when}",
    noData: "No data yet",
    noDataBody:
      "Nothing was sold in this period. Pick another range or check back after your next order.",
    totals: "Totals",
    breakdown: "Breakdown",
    byDay: "By day",
    previous: "Previous period: {value}",
    partialProfit:
      "Some items were sold without a cost price, so the profit shown is lower than complete.",
    planLockedTitle: "This needs advanced analytics",
    planLockedBody:
      "Your plan shows up to 31 days at a time from the last 90 days. Longer ranges and more breakdowns come with advanced analytics.",
    loadError: "The report could not be loaded.",
    key: "Item",
    groupsLabel: "Report group",
    groups: { sales: "Sales", money: "Money", operations: "Operations" },
    rangeLabel: "Period",
    range: { today: "Today", d7: "Last 7 days", d30: "Last 30 days", custom: "Custom range" },
    rangeSpan: "{from} – {to}",
    overTime: "{metric} over time",
    thisPeriod: "This period",
    averageDay: "Average {value} a day",
    byDim: "By {dim}",
    byDimLead: "{metric}, top {count}",
    share: "{pct}%",
    detailTitle: "Details",
    tabsLabel: "Reports in this group",
    compare: "Compare with the previous period",
    prevPeriod: "Previous period",
    vsPrevious: "{pct}% vs previous period",
    samePrevious: "Same as the previous period",
    newPrevious: "Nothing in the previous period",
    chartMetric: "Show on the chart",
    bucket: { day: "By day", week: "By week", month: "By month" },
    weekOf: "Week of {date}",
    shareLead: "Share of {metric}",
    shareEmpty: "Nothing to break down in this period.",
    search: "Search this list",
    noRows: "No rows match.",
    filterAll: "All",
    filterUnsold: "Not sold in this period",
    filterLow: "Low or out of stock",
    rowsCount: "{count} rows",
    moneyTitle: "Where the money stands",
    moneyLead: "Net sales split into collected, still to collect and refunded.",
    profitTitle: "From sales to profit",
    profitLead: "Sales after discounts, less the cost of the items sold.",
    deliveryTitle: "Delivery health",
    deliveryLead: "Of the parcels sent in this period.",
    returnsTitle: "Return health",
    returnsLead: "Returns against orders, and parcels returned to you against parcels sent.",
    stockTitle: "Stock value",
    stockLead: "What your stock cost and what it sells for, as of now.",
    potentialProfit: "Profit still in stock",
    viewInventory: "Open inventory",
    discountTitle: "How discounts were given",
    discountLead: "Coupon codes against other discounts (manual, automatic, flash deals).",
    otherDiscounts: "Other discounts",
    customerMixTitle: "New and returning",
    customerMixLead: "Customers who bought in this period.",
    repeatRate: "Bought more than once",
    topCustomers: "Top customers",
    customerCol: "Customer",
    noNames: "Names show for staff who may see customers.",
  },
  topics: {
    sales: "Sales",
    products: "Products",
    customers: "Customers",
    payments: "Payments",
    returns: "Returns",
    delivery: "Delivery",
    traffic: "Visitors",
    profit: "Profit",
    inventory: "Inventory",
    discounts: "Discounts",
  },
  dims: {
    total: "Day",
    channel: "Sales channel",
    method: "Payment method",
    product: "Product",
    category: "Category",
    staff: "Staff member",
    location: "Location",
    district: "District",
    courier: "Courier",
    coupon: "Coupon",
    source: "Traffic source",
    page: "Page",
    device: "Device",
  },
  keys: {
    none: "None",
    unknown: "Not given",
    online: "Online store",
    noCoupon: "Without a coupon",
    noCourier: "Not sent by courier",
    source: {
      direct: "Direct or typed in",
      google: "Google",
      facebook: "Facebook",
      instagram: "Instagram",
      tiktok: "TikTok",
      youtube: "YouTube",
      whatsapp: "WhatsApp",
      bing: "Bing",
    },
    device: {
      mobile: "Phone",
      tablet: "Tablet",
      desktop: "Computer",
      unknown: "Unknown device",
    },
    home: "Home page",
    other: "Everything else",
    channel: {
      web: "Online store",
      pos: "Shop counter",
      manual: "Phone and social",
      headless: "Custom storefront",
      marketplace: "Marketplace",
      ai: "root (AI assistant)",
    },
  },
  metrics: {
    orders: "Orders",
    cancelled: "Cancelled",
    units: "Items sold",
    gross_paisa: "Item sales",
    discount_paisa: "Discounts",
    delivery_paisa: "Delivery charges",
    tax_paisa: "Tax",
    net_paisa: "Net sales",
    average_order_paisa: "Average order",
    collected_paisa: "Collected",
    outstanding_paisa: "Still to collect",
    refunded_paisa: "Refunded",
    returns: "Returns",
    return_rate_bp: "Return rate",
    return_value_paisa: "Returned value",
    shipments: "Parcels sent",
    delivered: "Delivered",
    rto: "Returned to you (RTO)",
    rto_rate_bp: "RTO rate",
    delivery_rate_bp: "Delivery rate",
    average_delivery_minutes: "Average time to deliver",
    revenue_paisa: "Sales after discounts",
    cogs_paisa: "Cost of items",
    gross_profit_paisa: "Gross profit",
    margin_bp: "Margin",
    cost_missing_units: "Items without a cost",
    customers: "Customers",
    new_customers: "New customers",
    returning_customers: "Returning customers",
    repeat_customers: "Bought more than once",
    visitors: "Visitors",
    page_view: "Page views",
    product_view: "Product views",
    add_to_cart: "Added to cart",
    checkout_start: "Checkouts started",
    purchase: "Purchases",
    search: "Searches",
    view_to_cart_bp: "View to cart",
    cart_to_checkout_bp: "Cart to checkout",
    checkout_to_purchase_bp: "Checkout to purchase",
    conversion_bp: "Conversion",
    stock_units: "Items in stock",
    stock_value_cost_paisa: "Stock value at cost",
    stock_value_price_paisa: "Stock value at price",
    low_stock_variants: "Low in stock",
    out_of_stock_variants: "Out of stock",
    units_sold: "Items sold",
    discounted_orders: "Orders with a discount",
    discount_rate_bp: "Discount rate",
    coupon_orders: "Orders with a coupon",
    coupon_discount_paisa: "Coupon discounts",
    average_discount_paisa: "Average discount",
  },
  units: {
    hours: "{value} h",
    minutes: "{value} min",
  },
  export: {
    button: "Download CSV",
    preparing: "Preparing the file…",
    ready: "Your file is ready",
    download: "Download",
    failed: "The file could not be prepared. Try again.",
    queued: "The file is being prepared. It stays available for 7 days.",
    history: "Recent downloads",
    stateQueued: "Preparing",
    stateDone: "Ready",
    stateFailed: "Failed",
  },
  traffic: {
    activationTitle: "Visitor reports need activation",
    activationBody:
      "Your store already counts visits without cookies. Showing them here needs a read-only Analytics token from the platform owner. Until then, nothing is estimated.",
    consentTitle: "Visitor tracking",
    consentLead:
      "No cookies and no personal data. Visitors who turn on Do Not Track or Global Privacy Control are never counted.",
    consentLabel: "When to count visitors",
    consentNotice: "Count visits unless the visitor opts out (default)",
    consentOptIn: "Only after the visitor agrees",
    consentSaved: "Visitor tracking setting saved.",
    consentFailed: "The setting could not be saved. Try again.",
    consentWhat:
      "Choose when your online store counts a visit for these reports. It never changes what shoppers see or buy.",
    consentOwnerOnly: "Only staff who can change store settings can change this.",
    promisesLabel: "Privacy",
    promises: {
      noCookies: "No cookies",
      noPersonal: "No personal data",
      dnt: "Respects Do Not Track",
    },
    recommended: "Recommended",
    mode: {
      notice: {
        title: "Count every visit",
        body: "Counts each visit to your online store, unless the shopper has turned on Do Not Track or Global Privacy Control in their browser.",
      },
      opt_in: {
        title: "Only after the shopper agrees",
        body: "Counts a visit only after the shopper accepts tracking on your store. Use it if your market asks for consent first.",
      },
    },
    optInGapTitle: "Your store does not ask shoppers yet",
    optInGapBody:
      "There is no consent prompt on the online store yet, so with this choice no visits are counted and these reports stay empty. Switch back to Count every visit to keep counting.",
    funnel: "Shopping funnel",
    funnelLead: "How many visitors reached each step.",
    stepRate: "{pct}% went on to the next step",
    steps: {
      visitors: "Visited the store",
      product_view: "Viewed a product",
      add_to_cart: "Added to cart",
      checkout_start: "Started checkout",
      purchase: "Bought",
    },
    title: "Visitors and traffic",
  },
  leaderboard: {
    title: "Store ranking",
    lead: "See how your store compares with other stores, as a band only. No store's sales or name are ever shown to others.",
    optIn: "Join the ranking",
    optOut: "Leave the ranking",
    optedIn: "Your store is in the ranking.",
    ownerOnly: "Only the business owner can join or leave the ranking.",
    pending: "Your band appears after the next daily update.",
    notEnough:
      "Not enough stores have joined yet. Bands appear once at least {count} stores take part.",
    cohort: "Among {count} stores, last 30 days",
    ordersBand: "Orders",
    gmvBand: "Net sales",
    cohortLead: "Join to see your band for orders and net sales over the last 30 days.",
    cohortLeadIn: "Your band for orders and net sales over the last 30 days.",
    ladder: "The bands",
    ladderLead: "Your band is outlined once it is ready.",
    bands: {
      top_10: "Top 10%",
      top_25: "Top 25%",
      top_50: "Top half",
      bottom_50: "Lower half",
    },
  },
  widgets: {
    title: "Your dashboard",
    customize: "Customize",
    done: "Done",
    add: "Add",
    remove: "Remove",
    moveUp: "Move up",
    moveDown: "Move down",
    available: "More widgets",
    saved: "Dashboard saved.",
    empty: "No widgets yet. Choose Customize to add some.",
    // Collected and still to collect (owner, 2026-11-01): the split list header.
    ofNet: "Of net sales",
    amountShare: "Amount · share",
    names: {
      kpis: "Today at a glance",
      sales_trend: "Sales this week",
      collected_outstanding: "Collected and still to collect",
      top_products: "Top products",
      payment_methods: "Payment methods",
      courier_performance: "Courier performance",
      returns: "Returns",
      traffic_funnel: "Visitors",
      leaderboard: "Store ranking",
    },
  },
} as const;
